module.exports = __webpack_public_path__ + "img/gongjizhe.a90f1fd1.png";